<template>
  <section class="section">
    <h2 class="title">{{ t('appStore.accessibilityTitle') }}</h2>
    <p class="body">
      {{ t('appStore.accessibilityBody') }}
      <span class="link">{{ t('appStore.learnMore') }}</span>
    </p>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>
.section {
  padding: 24px 16px 0;
}

.title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.body {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #4b5563;
}

.link {
  color: #007AFF;
}
</style>
